import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatMoney } from "@/lib/api";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const navigate = useNavigate();

  const onAdd = (e) => {
    e.preventDefault();
    if (Array.isArray(product.sizes) && product.sizes.length > 0) {
      navigate(`/product/${product.id}`);
      toast.info("Choose a size to add this item.");
      return;
    }
    addItem(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.06 }}
      data-testid={`product-card-${product.id}`}
    >
      <Link
        to={`/product/${product.id}`}
        className="group block border border-ink/10 bg-white hover:-translate-y-1 hover:shadow-xl transition-all duration-300 overflow-hidden"
      >
        <div className="relative aspect-square overflow-hidden bg-secondary">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {product.is_bestseller && (
            <span className="absolute top-3 left-3 bg-brand text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1">
              Best Seller
            </span>
          )}
          <button
            onClick={onAdd}
            data-testid={`add-to-cart-${product.id}`}
            className="absolute bottom-3 right-3 bg-ink text-white w-10 h-10 flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 hover:bg-brand"
            aria-label="Add to cart"
          >
            <Plus size={18} />
          </button>
        </div>
        <div className="p-4">
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-1">
            {product.category}
          </p>
          <h3 className="font-display font-bold text-base leading-tight mb-2 line-clamp-1">
            {product.name}
          </h3>
          <p className="font-mono text-lg font-bold">{formatMoney(product.price)}</p>
        </div>
      </Link>
    </motion.div>
  );
}
